<div class="modalRegisterBank">
  <!-- <button class="buttonClose" (click)="close()" *ngIf="btnClose">
    <svg class="c-icon buttonClose__icon">
      <use xlink:href="#ic-close" />
    </svg>
  </button> -->
  <h1 class="title1 s-fontSize--mdl s-text--primary">
    Cadastre seus dados bancários
  </h1>
  <p class="s-fontWeight--light s-marginBottom-md">
    Para continuar o cadastro do seu lote e ser habilitado a vender na VinhoBid,
    precisamos dos seus dados bancários para realizarmos o repasse das suas
    vendas no final de cada leilão.
  </p>

  <form data-track="Formulário de Cadastro de Dados Bancários" [formGroup]="formRegisterBank"
    class="formRegister s-width-100" autocomplete="off">
    <div>
      <mat-form-field class="s-width-100" appearance="fill">
        <mat-label>Banco</mat-label>
        <input (input)="handleBankSearch(formRegisterBank.get('bank')?.value)" formControlName="bank"
          [matAutocomplete]="auto" matInput maxlength="100" placeholder="Digite o código ou nome do banco" />

        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let option of codeBankList" [value]="option.code + ' - ' + option.name">
            {{ option.code + " - " + option.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="formRegisterBank.get('bank').hasError('required')">
          Campo obrigatório!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="d-flex l-grid--between l-grid_col--wrap">
      <mat-form-field appearance="fill" class="formRegister__input">
        <mat-label>Agência </mat-label>
        <input matInput placeholder="Digite conforme seu banco (xxxxxx-x)" [mask]="bankAgMask" [validation]="false"
          formControlName="bankAg" [errorStateMatcher]="matcher" />
        <mat-error *ngIf="formRegisterBank.get('bankAg')?.hasError('required')">
          Campo obrigatório!
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="formRegister__input">
        <mat-label>Conta</mat-label>
        <input matInput placeholder="Conta" (blur)="onBlurBankCc()" formControlName="bankCc" [mask]="bankCcMask"
          [dropSpecialCharacters]="false"
          (input)="formRegisterBank.get('bankCc').setValue(formRegisterBank.get('bankCc').value?.toUpperCase())"
          placeholder="Digite conforme seu banco (xxxxxx-x)" />
        <mat-error *ngIf="formRegisterBank.get('bankCc')?.hasError('required')">
          Campo obrigatório!
        </mat-error>
      </mat-form-field>
      <span class="s-fontSize--xxs messageBankValores">Obs: Digite os valores da sua agência e conta com os dígitos
        conforme
        informado pelo seu banco (xxxxxx-x)
      </span>
    </div>
    <div>
      <label id="typeConta" class="formRegister__label-radio s-fontWeight--light">Selecione o tipo da conta</label>
      <mat-radio-group aria-labelledby="typeConta" formControlName="accountType">
        <mat-radio-button value="1" class="formRegister__radio">Conta corrente</mat-radio-button>
        <mat-radio-button value="2">Conta poupança</mat-radio-button>
        <mat-error *ngIf="isInputRadioValid(formRegisterBank)">
          Campo obrigatório!
        </mat-error>
      </mat-radio-group>
    </div>
    <div class="s-marginTop-mdl d-flex l-grid--between l-grid_col--wrap">

      <div *ngIf="!bankData?.[0]?.bankId" class="upload-box">
        <label class="m-titleSimple s-fontSize--sm label--document">
          Documento oficial com foto *
        </label>

        <ng-container *ngIf="canUpload(documentsStatus.identification); else uploadedOrApprovedDocumentTemplate">
          <label class="m-button m-button--outline m-button--upload s-width-100" for="uploadDocument">
            {{
            preview.documentFile
            ? "Arquivo anexado"
            : loadingUpload.documentFile
            ? "Enviando arquivo"
            : "Selecionar documento"
            }}
            <svg class="c-icon">
              <use xlink:href="#ic-arrow-upload" />
            </svg>
            <input #uploadDocumentInput accept=".jpg,.jpeg,.png,.pdf" id="uploadDocument" type="file"
              (change)="onFileChange($event, 'documentFile')" [disabled]="loadingUpload.documentFile" />
          </label>
        </ng-container>

        <ng-template #uploadedOrApprovedDocumentTemplate>
          <div class="document-status" [ngClass]="getDocumentStatusClass(documentsStatus.identification)">
            {{ getDocumentStatusText(documentsStatus.identification) }}
          </div>
        </ng-template>

        <mat-progress-bar mode="indeterminate" *ngIf="loadingUpload.documentFile" color="primary"></mat-progress-bar>

        <div class="m-pageRegisterLot_uploadedFiles s-marginTop-sm" *ngIf="preview.documentFile">
          <div class="m-pageRegisterLot_fileDisplay">
            <span class="m-pageRegisterLot_fileDisplay__name">
              {{ preview.documentFile.fileName }}
            </span>
            <button class="m-pageRegisterLot_fileDisplay__btn" (click)="removeFile('documentFile')" type="button">
              <svg class="c-icon">
                <use xlink:href="#ic-garbage-close" />
              </svg>
            </button>
          </div>
        </div>

        <mat-error
          *ngIf="formRegisterBank.get('documentFile').invalid && (formRegisterBank.get('documentFile').touched || formSubmitted)">
          Campo obrigatório!
        </mat-error>
        <mat-error *ngIf="formRegisterBank.get('documentFile').hasError('invalidType')">
          Formato inválido. Envie JPG, PNG ou PDF.
        </mat-error>
        <mat-error *ngIf="formRegisterBank.get('documentFile').hasError('maxSize')">
          Tamanho máximo permitido é {{ maxFileSizeMB }}MB.
        </mat-error>
      </div>

      <div *ngIf="!bankData?.[0]?.bankId" class="upload-box">
        <label class="m-titleSimple s-fontSize--sm label--document">
          Foto selfie com o documento *
        </label>

        <ng-container *ngIf="canUpload(documentsStatus.selfie); else uploadedOrApprovedTemplate">
          <label class="m-button m-button--outline m-button--upload s-width-100" for="uploadSelfie">
            {{
            preview.selfieFile
            ? "Arquivo anexado"
            : loadingUpload.selfieFile
            ? "Enviando arquivo"
            : "Selecionar documento"
            }}
            <svg class="c-icon">
              <use xlink:href="#ic-arrow-upload" />
            </svg>
            <input #uploadSelfieInput accept=".jpg,.jpeg,.png" id="uploadSelfie" type="file"
              (change)="onFileChange($event, 'selfieFile')" [disabled]="loadingUpload.selfieFile" />
          </label>
        </ng-container>

        <ng-template #uploadedOrApprovedTemplate>
          <div class="document-status" [ngClass]="getDocumentStatusClass(documentsStatus.selfie)">
            {{ getDocumentStatusText(documentsStatus.selfie) }}
          </div>
        </ng-template>

        <mat-progress-bar mode="indeterminate" *ngIf="loadingUpload.selfieFile" color="primary"></mat-progress-bar>

        <div class="m-pageRegisterLot_uploadedFiles s-marginTop-sm" *ngIf="preview.selfieFile">
          <div class="m-pageRegisterLot_fileDisplay">
            <span class="m-pageRegisterLot_fileDisplay__name">
              {{ preview.selfieFile.fileName }}
            </span>
            <button class="m-pageRegisterLot_fileDisplay__btn" (click)="removeFile('selfieFile')" type="button">
              <svg class="c-icon">
                <use xlink:href="#ic-garbage-close" />
              </svg>
            </button>
          </div>
        </div>

        <mat-error
          *ngIf="formRegisterBank.get('selfieFile').invalid && (formRegisterBank.get('selfieFile').touched || formSubmitted)">
          Campo obrigatório!
        </mat-error>
        <mat-error *ngIf="formRegisterBank.get('selfieFile').hasError('invalidType')">
          Formato inválido. Envie JPG ou PNG.
        </mat-error>
        <mat-error *ngIf="formRegisterBank.get('selfieFile').hasError('maxSize')">
          Tamanho máximo permitido é {{ maxFileSizeMB }}MB.
        </mat-error>
      </div>


    </div>

    <div class="s-marginTop-md" *ngIf="!bankData?.[0]?.bankId">
      <mat-checkbox formControlName="isPoliticallyExposedPerson" color="primary">
        Pessoa Politicamente Exposta
      </mat-checkbox>
    </div>

    <ng-container *ngIf="typeUser === 'PJ' && !bankData?.[0]?.bankId">
      <mat-form-field appearance="fill" class="s-width-100 s-marginTop-md">
        <mat-label>Previsão de faturamento (R$)</mat-label>
        <input matInput type="text" formControlName="estimatedRevenue" placeholder="Informe a previsão"
          mask="separator.2" thousandSeparator="." decimalMarker="," prefix="R$ " />
        <mat-error *ngIf="formRegisterBank.get('estimatedRevenue')?.hasError('required')">
          Campo obrigatório!
        </mat-error>
        <mat-error *ngIf="formRegisterBank.get('estimatedRevenue')?.hasError('min')">
          O valor deve ser maior que 0!
        </mat-error>
      </mat-form-field>
      <p class="s-fontSize--xxs s-text--gray s-marginTop-xxs">
        Este dado é necessário para a conclusão do cadastro na plataforma de pagamentos IUGU.
        Caso sua empresa ainda não possua faturamento, insira a previsão de faturamento para os próximos 6 meses.
      </p>
    </ng-container>

    <ng-container *ngIf="typeUser === 'PF' && !bankData?.[0]?.bankId">
      <mat-form-field appearance="fill" class="s-width-100 s-marginTop-md">
        <mat-label>Renda Estimada (R$)</mat-label>
        <input matInput type="text" formControlName="estimatedRevenue" placeholder="Informe a renda estimada"
          mask="separator.2" thousandSeparator="." decimalMarker="," prefix="R$ " />
        <mat-error *ngIf="formRegisterBank.get('estimatedRevenue')?.hasError('required')">
          Campo obrigatório!
        </mat-error>
        <mat-error *ngIf="formRegisterBank.get('estimatedRevenue')?.hasError('min')">
          O valor deve ser maior que 0!
        </mat-error>
      </mat-form-field>
      <p class="s-fontSize--xxs s-text--gray s-marginTop-xxs">
        Este dado é necessário para a conclusão do cadastro na plataforma de pagamentos IUGU.
      </p>
    </ng-container>

    <div class="s-marginTop-mdl d-flex l-grid--middle s-width-100 l-grid--end">
      <button class="m-button m-button--primary button__back s-marginRight-lg" (click)="returnPage()"
        *ngIf="modalData?.enableBackButton">
        Voltar
      </button>

      <button type="button" data-track="Botão de cadastrar dados bancários" class="m-button button__register"
        (click)="registerBank(formRegisterBank)" [disabled]="loading || !isFormReadyToSave()">
        <span *ngIf="loading" class="d-flex l-grid--middle">
          <mat-spinner [diameter]="14">Loading</mat-spinner> Salvando...
        </span>
        <span *ngIf="!loading"> Salvar </span>
      </button>
    </div>
  </form>
</div>
